module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'inline': _vm.placement === 'inline'
    }
  }, [(_vm.identifier !== null && _vm.options.content !== null && _vm.options.content !== '') ? _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.options),
      expression: "options"
    }],
    class: {
      'spaced': _vm.space
    },
    style: (_vm.styleOptions),
    on: {
      "click": function($event) {
        return _vm.click()
      }
    }
  }, [(_vm.icon) ? _c('i', {
    class: 'fas fa-' + _vm.icon
  }) : _c('i', {
    staticClass: "fas fa-question"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e3ac208"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/dTooltip.vue
// module id = 878
// module chunks = 0